export interface Deal {
  id: string;
  title: string;
  subtitle: string;
  discount: string;
  image: string;
  alt: string;
  badge: string;
  badgeColor: string;
  originalPrice: number;
  salePrice: number;
  currency: string;
  expiresIn: string;
}

export const DEALS: Deal[] = [
{
  id: 'deal-1',
  title: 'El Aurassi Hotel',
  subtitle: 'Algiers · 2 nights min.',
  discount: '30% OFF',
  image: 'https://img.rocket.new/generatedImages/rocket_gen_img_11b4952b7-1775932741332.png',
  alt: 'Luxury hotel overlooking Algiers bay with panoramic Mediterranean views',
  badge: 'Flash Deal',
  badgeColor: 'bg-red-500',
  originalPrice: 12500,
  salePrice: 8750,
  currency: 'DZD',
  expiresIn: '2d 14h'
},
{
  id: 'deal-2',
  title: 'Sheraton Oran',
  subtitle: 'Oran · Sea View Room',
  discount: '25% OFF',
  image: 'https://img.rocket.new/generatedImages/rocket_gen_img_19791a7de-1773568773193.png',
  alt: 'Modern beachfront hotel in Oran with swimming pool and sea views',
  badge: 'Limited',
  badgeColor: 'bg-orange-500',
  originalPrice: 9800,
  salePrice: 7350,
  currency: 'DZD',
  expiresIn: '5d 8h'
},
{
  id: 'deal-3',
  title: 'Tamanrasset Desert Lodge',
  subtitle: 'Sahara · All Inclusive',
  discount: '20% OFF',
  image: "https://images.unsplash.com/photo-1706622618242-b026f266057b",
  alt: 'Luxury desert lodge surrounded by Saharan dunes and Hoggar mountains at sunset',
  badge: 'Early Bird',
  badgeColor: 'bg-primary-500',
  originalPrice: 15000,
  salePrice: 12000,
  currency: 'DZD',
  expiresIn: '1d 6h'
},
{
  id: 'deal-4',
  title: 'Cirta Hotel Constantine',
  subtitle: 'Constantine · Heritage Wing',
  discount: '15% OFF',
  image: "https://images.unsplash.com/photo-1721429432323-3cb869810052",
  alt: 'Historic hotel perched above the gorges of Constantine with bridge views',
  badge: 'Weekend Only',
  badgeColor: 'bg-accent-500',
  originalPrice: 7200,
  salePrice: 6120,
  currency: 'DZD',
  expiresIn: '3d 0h'
}];


export interface PropertyCategory {
  id: string;
  name: string;
  icon: string;
  count: number;
  image: string;
  alt: string;
}

export const PROPERTY_CATEGORIES: PropertyCategory[] = [
{ id: 'cat-hotel', name: 'Hotels', icon: '🏨', count: 214, image: "https://img.rocket.new/generatedImages/rocket_gen_img_11630356e-1773092856673.png", alt: 'Elegant hotel lobby with marble floors and chandelier' },
{ id: 'cat-riad', name: 'Riads', icon: '🏡', count: 87, image: "https://img.rocket.new/generatedImages/rocket_gen_img_11b2e9db7-1773148517722.png", alt: 'Traditional Algerian riad courtyard with fountain and mosaic tiles' },
{ id: 'cat-resort', name: 'Resorts', icon: '🏖️', count: 43, image: "https://img.rocket.new/generatedImages/rocket_gen_img_1fcba872e-1772836359484.png", alt: 'Luxury beach resort with infinity pool overlooking the Mediterranean' },
{ id: 'cat-desert', name: 'Desert Camps', icon: '🏕️', count: 29, image: "https://img.rocket.new/generatedImages/rocket_gen_img_17c75a3ea-1773092861096.png", alt: 'Luxury desert camp with traditional tents under a starry Saharan sky' },
{ id: 'cat-villa', name: 'Villas', icon: '🏠', count: 61, image: "https://img.rocket.new/generatedImages/rocket_gen_img_12beb5523-1776710537597.png", alt: 'Private villa with terrace and panoramic mountain views in Algeria' },
{ id: 'cat-apart', name: 'Apartments', icon: '🏢', count: 132, image: "https://img.rocket.new/generatedImages/rocket_gen_img_1823ffea2-1772225493503.png", alt: 'Modern furnished apartment with city views and open plan living area' }];